import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IRisk } from '../../../../types';

interface Props {
  showRisks: boolean;
  hasCriminalConvictions: string;
  criminalConvictionReason?: string;
  riskList?: IRisk['personalInfoRisk']['criminalConvictions'];
}

function CriminalConvictionAndDisability({
  showRisks,
  hasCriminalConvictions,
  criminalConvictionReason,
  riskList = [],
}: Props) {
  return (
    <>
      <SummaryRow
        key="hasCriminalConviction"
        label="Has Criminal Convictions"
        fullLabel="Have you ever had any criminal convictions, charges, or penalties in the UK or any other country?"
        value={hasCriminalConvictions}
        isRisk={showRisks && riskList.includes(Q.HAS_CRIMINAL_CONVICTIONS)}
      />

      <SummaryRow
        key="criminalConvictionInfo"
        label="Criminal Convictions Info"
        fullLabel="Please provide more information on the date and nature of the offence(s)"
        value={criminalConvictionReason || ''}
        isRisk={showRisks && riskList.includes(Q.CRIMINAL_CONVICTIONS_REASON)}
      />
    </>
  );
}

export default CriminalConvictionAndDisability;
